var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultState } from './state';
import { UPDATE_CART_ITEM_EDITOR, UPDATE_PHOTO_PRODUCT_ITEM, UPDATE_PHOTO_UPLOAD_PROCESS, UPDATE_SELECTED_PHOTO, UPDATE_SELECTED_PRODUCT_ITEM, UPLOAD_PHOTOS_ERROR, UPLOAD_PHOTOS_REQUEST, UPLOAD_PHOTOS_SUCCESS, } from './actionTypes';
var reducer = function (state, action) {
    var _a, _b, _c;
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case UPDATE_PHOTO_UPLOAD_PROCESS:
            return __assign(__assign({}, state), { photoUpload: __assign(__assign({}, state.photoUpload), { uploadProgress: __assign({}, action.payload) }) });
        case UPLOAD_PHOTOS_REQUEST:
            return __assign(__assign({}, state), { photoUpload: __assign(__assign({}, state.photoUpload), { status: 'loading' }) });
        case UPLOAD_PHOTOS_SUCCESS:
            return __assign(__assign({}, state), { photoUpload: __assign(__assign({}, state.photoUpload), { status: 'loaded', uploadProgress: { total: 0, loaded: 0 } }) });
        case UPLOAD_PHOTOS_ERROR:
            return __assign(__assign({}, state), { photoUpload: __assign(__assign({}, state.photoUpload), { status: 'error' }) });
        case UPDATE_SELECTED_PHOTO:
            return __assign(__assign({}, state), { selectedPhoto: action.photo });
        case UPDATE_SELECTED_PRODUCT_ITEM:
            return __assign(__assign({}, state), { selectedProductItem: action.item });
        case UPDATE_PHOTO_PRODUCT_ITEM:
            return __assign(__assign({}, state), { photos: __assign(__assign({}, state.photos), { items: action.photos }), selectedPhoto: action.selectedPhoto });
        case UPDATE_CART_ITEM_EDITOR:
            return __assign(__assign({}, state), { productItems: { status: 'loaded', items: action.payload.productItems }, photos: __assign(__assign({}, state.photos), { status: 'loaded', items: action.payload.photos }), selectedPhoto: (_a = action.payload.selectedPhoto) !== null && _a !== void 0 ? _a : null, selectedProductItem: (_c = (_b = action.payload.selectedPhoto) === null || _b === void 0 ? void 0 : _b.product_item) !== null && _c !== void 0 ? _c : null });
    }
    return state;
};
export default reducer;
